import React from 'react';

const Error = ({ text }) => (
  <div className="alert alert-danger">
    <p style={{ marginBottom: '0px', textAlign: 'left' }}>{text}</p>
  </div>
);

export default Error;



// WEBPACK FOOTER //
// ./src/components/common/form/error.js